/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RescheduleTransferenceModalAliases {
  CARD_APPOINTMENTS = 'card-appointments',
  CONTEXTUAL_BAR_DECK_ITEMS = 'contextual-bar-deck-items',
  DECK_APPOINTMENTS = 'deck-appointments',
  FETCH_APPOINTMENTS = 'fetch-appointments',
  GLOBAL_ACTIONS = 'global-actions',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_RESCHEDULE = 'layout-reschedule',
  LAYOUT_RESCHEDULE_PANEL = 'layout-reschedule-panel',
  LAYOUT_RESCHEDULE_TRANSFERENCE_MODAL = 'layout-reschedule-transference-modal',
  LAYOUT_TOAST_NOTIFICATION = 'layout-toast-notification',
  PANEL_DECK_ITEMS = 'panel-deck-items',
  PANEL_TITLE = 'panel-title',
  PANEL_TOAST = 'panel-toast',
  PANEL_TOAST_NOTIFICATION = 'panel-toast-notification',
  RESCHEDULE_CANCEL_BUTTON = 'reschedule-cancel-button',
  RESCHEDULE_CONFIRM_BUTTON = 'reschedule-confirm-button',
  TEXT_TITLE = 'text-title',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { RescheduleTransferenceModalAliases };
